export class Line {
  constructor(difference) {
    this.width = 18
    this.height = 600
    this.top = 10
    this.left = 10
    this.innerElement = "cxVerticalLine"
    this.content = "竖线"
    this.opacity = 100
    this.rotate = 0
    this.bgColor = "rgba(0, 0, 0, 1)"
    this.bgColorIsThemeColor = false
    this.lineType = "solid"
    this.borderWidth = 2
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
